import { Field, FieldControllerType } from '@gemini/lux-ds-pms';
import { ContactDetailsInfo, Patient } from '@store/patientStore';
import { mergeObjects } from '@utils/functions';
// import { Field } from '@gemini/lux-ds-pms';

export type NestedObject = {
  [key: string]: string | NestedObject | undefined | boolean;
};

export const getDefaultFieldValue = (type: FieldControllerType) =>
  type === FieldControllerType.CHECKBOX || type === FieldControllerType.TOGGLE
    ? false
    : '';

const isPlainObject = (value: unknown): value is NestedObject =>
  typeof value === 'object' &&
  value !== null &&
  !Array.isArray(value) &&
  !(value instanceof Date);

export const shouldNormalizeFieldValue = (
  value: unknown,
  type: FieldControllerType,
) => {
  if (typeof value === 'undefined' || value === null) return false;
  if (type === FieldControllerType.UPLOAD) return false;
  if (type === FieldControllerType.AUTOCOMPLETE) return false;

  if (
    typeof value === 'string' &&
    ['[objectobject]', '[object,object]'].includes(
      value.replace(/\s/g, '').toLowerCase(),
    )
  ) {
    return true;
  }

  return (
    (typeof value === 'object' && !(value instanceof Date)) ||
    (type === FieldControllerType.CHECKBOX && typeof value !== 'boolean') ||
    (type === FieldControllerType.TOGGLE && typeof value !== 'boolean')
  );
};

export function flattenFields(
  fields: Field[],
  patient: Patient | ContactDetailsInfo,
  prevRes?: NestedObject,
): NestedObject {
  const res = prevRes || {};
  fields.forEach(field => {
    generateObjFromId(field.id, res, !field.children, field.type);
    if (field.children) {
      flattenFields(field.children, patient, res);
    }
  });
  const merged = mergeObjects(res, patient, false);
  normalizeFormValues(fields, merged);

  return merged;
}

export const normalizeFormValues = (fields: Field[], values: NestedObject) => {
  fields.forEach(field => {
    if (field.children) {
      normalizeFormValues(field.children, values);
      return;
    }

    normalizeFieldValue(field.id, field.type, values);
  });
};

const normalizeFieldValue = (
  id: string,
  type: FieldControllerType,
  values: NestedObject,
) => {
  if (!id) return;

  const ids = id.split('.');
  let parent = values;

  for (let i = 0; i < ids.length - 1; i++) {
    const nextValue = parent[ids[i]];

    if (!isPlainObject(nextValue)) {
      return;
    }

    parent = nextValue;
  }

  const fieldId = ids[ids.length - 1];

  if (!Object.prototype.hasOwnProperty.call(parent, fieldId)) {
    parent[fieldId] = getDefaultFieldValue(type);
    return;
  }

  if (shouldNormalizeFieldValue(parent[fieldId], type)) {
    parent[fieldId] = getDefaultFieldValue(type);
  }
};

const generateObjFromId = (
  id: string,
  res: NestedObject,
  setValue: boolean,
  type: FieldControllerType,
) => {
  if (id) {
    const ids = id.split('.');
    // entro dentro l'oggetto
    if (ids.length > 1) {
      // console.log('#id', res, ids[0], id);
      if (!Object.prototype.hasOwnProperty.call(res, ids[0])) {
        res[ids[0]] = {};
      }
      const newIds = ids.slice(1);
      generateObjFromId(
        newIds.join('.'),
        res[ids[0]] as NestedObject,
        setValue,
        type,
      );
    } else {
      if (typeof res === 'object' && setValue) {
        res[ids[0]] = getDefaultFieldValue(type);
      }
    }
  }
};
